// @ts-nocheck
import React from 'react';
import {
  Button,
  Box,
  Flex,
  useColorModeValue,
  Text,
  Tooltip,
  theme,
} from "@chakra-ui/react";
import { useSession } from "next-auth/react";
import { TweetComposer } from ".";
import { postReply } from "../../controllers/schedule";
import { getAccount } from 'utils/sessionHelper';
import { getToken } from "../../firebaseClient";
import { RateLimiter } from "limiter";
import toast from "react-hot-toast";
import { TweetContext } from '../../context/tweetContext';
import { formatDistance } from "date-fns";
import * as analytics from "../../utils/analytics";
import { likePost } from "controllers/miscellaneous";
import { MainContext } from "context/mainContext";
import { layerStyle, variant } from 'theme/names';
import { CardList } from '../cardList'
import { useCredit, getCreditBack, checkCredit } from "controllers/subscription";
import { CustomToast } from 'components/toasts/CustomToast';
import { getCachedKey, updateCachedKey } from "utils/localforageHelpers";
import { ez4castApiUrls } from "utils/ez4cast";

let limit = 10;
const limiter = new RateLimiter({ tokensPerInterval: limit, interval: "hour" });
let startLimitationUTCHour = 14;
let endLimitationUTCHour = 18;
let nowRef = new Date();
const date = new Date(nowRef.getFullYear(), nowRef.getMonth(), nowRef.getDate(), endLimitationUTCHour, 0, 0);
const endLimitation = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
const linkedinRepliesUrl = ez4castApiUrls.generateSmartReplies.prod;
const cards = [
  {
    label: "🤓 Add value",
    title: "🤓",
    key: "addValue"
  },
  {
    label: "👏 Congratulate",
    title: "👏",
    key: "congratulate"
  },
  {
    label: "🙏 Say thank you",
    title: "🙏",
    key: "thank"
  }
];

export const ReplyComposer = ({ tweet, removeTweet, addRemovedTweet, isFocused = false }) => {
  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"
  const [refresh, refresher] = React.useState({});
  const [isPosting, setIsPosting] = React.useState(false);
  const [isGenerating, setIsGenerating] = React.useState(false);
  const [isReplied, setIsReplied] = React.useState(false);
  const refComposer = React.createRef();
  const tweetContext = React.useContext(TweetContext);
  const mainContext = React.useContext<any>(MainContext);

  let isLocked = false;

  const onUpdate = async (state) => {
    // console.log("onUpdate");
    tweet.reply = state?.text;
  }

  const generateReplies = async (topic) => {
    const token = await getToken(session, "aiReplies");

    setIsGenerating(true)

    const useCreditBoolean = await useCredit(session, mainContext, "creditsBestai", false)
    // start toast custom
    const toastIdCustom = toast.loading(<CustomToast useCreditBoolean={useCreditBoolean} />);

    const data = {
      topic,
      idUser: session?.user?.uid as string,
      post: [{
        author: tweet.user.name,
        post: tweet.fullText,
      }],
      useBestAi: useCreditBoolean,
    }

    try {
      const res = await fetch(linkedinRepliesUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tokenuserid: data?.idUser ?? "",
        },
        credentials: "same-origin",
        body: JSON.stringify({ ...data, isInfluentLeader: true }),
      });

      const response = await res.json()
      tweet.reply = response?.data?.replies[0];
      refresher({});
      tweetContext.setIsTweetTextChanged(true);
    } catch (error) {
      getCreditBack(session);
      console.log({ error });
      toast.error("Error generating reply please retry or contact the support");
    }

    setIsGenerating(false)
    // end toast custom
    toast.dismiss(toastIdCustom);
  }

  const sendReply = async () => {

    if (! await useCredit(session, mainContext, "creditsReplies"))
      return;

    let text = refComposer.current.textState().text;
    tweet.reply = text;

    if (!text) {
      toast.error(`You need to write something`);
      return;
    }

    if (text.length > 1200) {
      toast.error(`Your reply is too long`);
      return;
    }

    // console.log(getAccount(session));

    if (!getAccount(session)?.access_token) {
      tweetContext.onOpenCredentials();
      return;
    }

    tweet.isReplied = true;
    removeTweet(tweet);

    //@ts-ignore
    console.log("send Tweet: " + JSON.stringify(refComposer?.current?.textState()));
    let dataToSend = {
      id_str: tweet.idUgcPost || tweet.id_str,
      idUser: getAccount(session)?.id,
      idAccount: getAccount(session)?.idAccount,
      accessToken: getAccount(session).access_token,
      text: text,
    }
    let isSuccess = await postReply(setIsPosting, dataToSend, tweetContext, session);

    // when auto like is active
    if (isSuccess && getAccount(session)?.autoLikeOnReply) {
      const likePayload = {
        postUrn: tweet.idUgcPost || tweet.id_str,
        accessToken: getAccount(session).access_token,
        idAccount: getAccount(session).idLinkedinOfficial ?? getAccount(session).idAccount,
        idLinkedin: getAccount(session).idLinkedin,
      }
      const data = await likePost(session, likePayload, tweet);
      if (data?.success) {
        // toast.success("Post liked");
      } else {
        // toast.error("Failed to like post");
      }
    }

    if (!isSuccess) {
      tweet.isReplied = false;
      getCreditBack(session, "creditsReplies");
      addRemovedTweet(tweet);
    }

    if (isSuccess) {
      setIsReplied(true);
      const repliedTweets = await getCachedKey("allRepliedTweets");
      let newRepliedTweets = repliedTweets?.tweets ?? [];
      newRepliedTweets.push(tweet.id_str);
      updateCachedKey("allRepliedTweets", { tweets: newRepliedTweets });
    }

  }

  const lgFrom = "#FF9100"; // theme.colors.red[400];
  const lgTo = "#DB00FF"; // theme.colors.blue[400];
  const bgColor = theme.colors.white;
  let gradientProps = {
    color: "gray.900",
    border: '2px solid',
    borderColor: 'transparent',
    borderRadius: 'lg',
    background: `linear-gradient(${bgColor}, ${bgColor}) padding-box, linear-gradient(135deg, ${lgFrom}, ${lgTo}) border-box`,
    _hover: {
      background: `linear-gradient(${lgFrom}, ${lgTo}) padding-box`,
      color: "white",
    },
    _active: {
      // bg: '#dddfe2',
      transform: 'scale(1.04)',
      opacity: '0.7',
    },
    _focus: {
      boxShadow: 'none',
    }
  }

  let replyTootlTip = typeof window !== "undefined" && window?.navigator?.userAgentData?.platform?.includes("mac") ? "Cmd-Enter" : "Ctrl-Enter";
  if (tweet?.zFull?.socialDetail?.socialPermissions?.canPostComments === false)
    replyTootlTip = "Comments are restricted on this post";

  return (
    <Box
      position="relative"
      layerStyle={layerStyle["bg.border.rounded"]}
      p={4}
    >
      {isLocked && (
        <Flex
          position="absolute"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          h="100%"
          w="100%"
          p={5}
        >
          <Flex
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            bg={useColorModeValue("gray.100", "gray.800")}
            rounded="md"
            p={5}
            zIndex={100}
          >
            <Text textStyle={textStyle["body.medium.light"]} align="center">
              We currently observe a surge in traffic and we had to disable
              tweet reply.
            </Text>
            <Text
              textStyle={textStyle["body.medium.light"]}
              align="center"
              mt={4}
            >
              Replies will be back in{" "}
              {formatDistance(endLimitation, new Date(), {
                addSuffix: false,
              })}
            </Text>
            <Button
              variant={variant.Button.primary}
              // colorScheme="twitter"
              mt={5}
              maxW="200px"
              as="a"
              target="_blank"
              href={`https://twitter.com/${tweet.twUserName}/status/${tweet.id_str}`}
            >
              Reply on Twitter
            </Button>
          </Flex>
        </Flex>
      )}
      <TweetComposer
        ref={refComposer}
        //@ts-ignore
        disableHeader={true}
        disableImage={true}
        disableAiContinue={true}
        isDisabled={isReplied || tweet.isReplied || isLocked}
        mode="engage"
        submit={sendReply}
        onUpdate={onUpdate}
        initText={tweet.reply}
        isFocused={isFocused}
        removeTweet={removeTweet}
        tweet={tweet}
        disableGif={true}
        disableSuggestion={true}
      />

      <Box mt={0} display="flex" justifyContent="flex-end">
        <CardList
          cards={cards}
          onClick={generateReplies}
          isLoading={isGenerating}
        />
        <Tooltip label={replyTootlTip} shouldWrapChildren>
          <Button
            ml={5}
            isLoading={isPosting}
            isDisabled={
              isReplied ||
              tweet.isReplied ||
              isLocked ||
              tweet?.zFull?.socialDetail?.socialPermissions
                ?.canPostComments === false
            }
            variant="primary"
            // colorScheme="blue"
            // bg="blue.700"
            // color="white"
            // _hover={{ bg: "blue.600" }}
            onClick={sendReply}
          >
            Reply
          </Button>
        </Tooltip>
      </Box>
    </Box>
  );
}